import { render, staticRenderFns } from "./ContractsChart.vue?vue&type=template&id=bb715c34"
import script from "./ContractsChart.vue?vue&type=script&lang=js"
export * from "./ContractsChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports